"use clients"


import Button from "@/ui/Button";
import React from "react";
import Image from "next/image";
import developersImg from "@/images/contacts/developer.webp";
import { useTranslations } from "next-intl";


interface Props {
  onAddContacts: () => void;
  isLoading?: boolean;
  isOwner?: boolean;
}

const AddContactsHolder: React.FC<Props> = (props) => {
  const t = useTranslations("HiddenFields");
  return (
    <div className="flex flex-col justify-center items-center">
      <p className="text-[#1B1B1B] font-normal text-[18px] tracking-normal text-center align-middle mb-[40px] lg:mb-[54px]">
        {props.isOwner ? t("getFetchOwner") : t("getFetch")}
      </p>
      <div className="relative w-full max-w-[596px] aspect-[596/293] mb-[32px] lg:mb-[45px]">
        <Image
          src={developersImg}
          alt={t("getFetchOwner")}
          fill
          priority
          sizes="(max-width: 640px) 100vw, 596px"
          className="object-contain"
        />
      </div>
      <p className="text-[#1B1B1B] font-normal text-[18px] tracking-normal text-center align-middle mb-[20px] lg:mb-[34px]">
        {props.isOwner ? t("contactsHiding") : t("developerContactsHiding")}
      </p>
      <Button
        color="red"
        type="button"
        onClick={props.onAddContacts}
        isLoading={props.isLoading}
      >
        {t("showContacts")}
      </Button>
    </div>
  );
};

export default AddContactsHolder;
